import actiontypes from '../actiontypes'
import _ from 'common-tools/LodashHelper'

let actions = {}

actions[actiontypes.Layout.AddBreadCrumbKey] = (state, action) => {
  let newState = _.merge({}, state)

  let match = _.find(newState.BreadCrumbKeys, { key: action.payload.key })

  if (match) {
    match.value = action.payload.value
  } else {
    newState.BreadCrumbKeys.push(action.payload)
  }

  return newState
}

actions[actiontypes.Layout.ClearBreadCrumbKeys] = (state, action) => {
  let newState = _.merge({}, state)

  newState.BreadCrumbKeys = []
  return newState
}

export default (state = {
  BreadCrumbKeys: []
}, action) => {
  if (_.startsWith(action.type, actiontypes.Layout.Prefix)) {
    return actions[action.type](state, action)
  } else {
    return state
  }
}
